




























import { Button, Header, Container, Logo } from '../atoms'
import { Vue, Component } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import { APP_MODULE, TRANSLATE } from '@/store/modules/app/constant'

@Component({
  components: {
    Container,
    Logo,
    Header,
    Button
  },
  computed: {
    ...mapGetters(APP_MODULE, [TRANSLATE])
  }
})
export default class Incident extends Vue {
  back() {
    this.$router.go(-1)
  }
}
